import React from 'react';
import PropTypes from 'prop-types';
import ArrowDown from "../../../../svg/arrow-down-right.svg";

// import PlayReelXl from '../../../../svg/play-show-xl.svg';
// import PlayReelSm from '../../../../svg/play-real-sm.svg';

const ContentCenter = ({ title, description }) => {
  const directorsToLink = ['CIGO', 'BELLESIA', 'BIONDINI', 'SOLDATI'];
  const showLink = title && directorsToLink.some(name => title.toUpperCase().includes(name));

  return (
    <>
      <div className="content-center">
        <div className="content-center__info">
         {title == 'Zero Factory AI Division' ? '' : <span className="main-decription">{description}</span>}
          <h1 className="h1">{title}</h1>
          <br />
          {showLink && (
            <div className="d-flex align-items-center">
              <a href="https://www.cartellodirectors.com/pages/contact" target="_blank" rel="noopener noreferrer" className="scroll-down">
              <span className="scroll-down__title">Represented abroad by Cartello Directors</span>
              <span className="scroll-down__icon">
                <ArrowDown />
              </span>
          </a>
            </div>
          )}
        </div>
        {/* <button className="play-showreel" onClick={playReel}>
          <PlayReelXl className="play-showreel__icon-xl" />
          <PlayReelSm className="play-showreel__icon-sm" />
          <span className="play-showreel__title">Play showreel</span>
        </button> */}
      </div>
      
    </>
  );
};

ContentCenter.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  playReel: PropTypes.func,
};

export default ContentCenter;
